import React from 'react';
import { useNavigate } from 'react-router-dom';
//import { useAuth } from './contexts/AuthContext';
import { Zap, Sparkles, LogOut, ArrowRight, MessageSquare, Shield, Mic } from 'lucide-react';
import { useQuery, useAction,useMutation } from 'convex/react';
import { api } from './convex/_generated/api';

export default function Indexsaitravel() {
  const navigate = useNavigate();
  const sessionId = localStorage.getItem('session_id') || '';
  
  
  const user = useQuery(api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
  );
  const logoutUser = useAction(api.mfa.logoutUser);

  const handleSignOut = async () => {
    if (user) {
      await logoutUser({ sessionId });
      localStorage.removeItem('session_id');
      navigate('/');
    } else {
      navigate('/auth');
    }
  };

  const features = [
    {
      icon: <MessageSquare size={24} color="#fff" />,
      title: 'AI Travel',
      description: 'Discover spending patterns',
    },
    //{
      //icon: <Shield size={24} color="#fff" />,
      //title: 'Pushback Responses',
      //description: 'Know exactly what to say when they push back. 4 responses per situation.',
    //},
    //{
     // icon: <Mic size={24} color="#fff" />,
      //title: 'Voice Playback',
      //description: 'Listen to your script out loud before the conversation. Practice makes perfect.',
    //},
  ];

return (
    <div style={S.page}>
      <div style={S.glow1} />
      <div style={S.glow2} />

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes float { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(-10px); } }
        .feature-card:hover { border-color: rgba(99,102,241,0.5) !important; transform: translateY(-4px); background: #0f1729 !important; }
        .cta-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(99,102,241,0.4); }
        .stat-card:hover { border-color: rgba(99,102,241,0.3) !important; }
      `}</style>

      {/* Header */}
      <header style={S.header}>
        <div style={S.headerInner}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={S.logoIcon}><Zap size={16} color="#fff" /></div>
            <span style={S.logoText}>Travel</span>
            <span style={S.logoBeta}>BETA</span>
          </div>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button onClick={handleSignOut} style={S.signOutBtn}>
              <LogOut size={14} />
              {user ? 'Sign Out' : 'Sign In'}
            </button>
            <button onClick={() => navigate(user ? '/dashboard' : '/auth')} style={S.navBtn}>
              {user ? 'Dashboard →' : 'Get Started →'}
            </button>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section style={S.hero}>
        <div style={{ ...S.badge, animation: "fadeUp 0.4s ease both" }}>
          <Zap size={14} color="#6366f1" />
          <span>Travel</span>
        </div>

        <h1 style={{ ...S.heroTitle, animation: "fadeUp 0.5s ease both" }}>
          Get More Customers<br />
          <em style={{ fontStyle: "normal", background: "linear-gradient(90deg, #6366f1, #8b5cf6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
            Real Time Transaction Monitoring
          </em>
        </h1>

        <p style={{ ...S.heroSubtitle, animation: "fadeUp 0.6s ease both" }}>
          Anomaly<br />
          Risk Alerts
        </p>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center", marginBottom: 40, animation: "fadeUp 0.7s ease both" }}>
          {["🎯 AI Travel", "📧 Transactions", "🎬 Discovery" ].map((s, i) => (
            <span key={i} style={S.tag}>{s}</span>
          ))}
        </div>

        <button
          className="cta-btn"
          onClick={() => navigate((user?.role === 'premium')   ? '/dashboard' : '/auth')}
          style={{ ...S.ctaBtn, animation: "fadeUp 0.8s ease both" }}
        >
         {user?.role === 'premium' ? 'Open Generator' : 'Start Free Today'} <ArrowRight size={18} />
        </button>

        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.3)", marginTop: 12 }}>
          Setup in 2 minutes
        </p>
      </section>

      {/* Stats */}
      <section style={S.stats}>
        {[
          ["10x", "Behavioral Analytics"],
          ["AI", "Interactive Dashboards & Insights"],
        ].map(([n, l], i) => (
          <div key={i} className="stat-card" style={S.statCard}>
            <strong style={S.statNum}>{n}</strong>
            <span style={S.statLabel}>{l}</span>
          </div>
        ))}
      </section>

      {/* Features */}
      <section style={S.features}>
        <h2 style={S.sectionTitle}>Everything in one platform</h2>
        <p style={S.sectionSubtitle}>Interactive Dashboards & Insights</p>
        <div style={S.featureGrid}>
          {features.map((f, i) => (
            <div key={i} className="feature-card" style={{ ...S.featureCard, transition: "all 0.2s" }}>
              <div style={S.featureIcon}>{f.icon}</div>
              <h3 style={S.featureTitle}>{f.title}</h3>
              <p style={S.featureText}>{f.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How it works */}
      <section style={S.howItWorks}>
        <h2 style={S.sectionTitle}>How it works</h2>
        <p style={S.sectionSubtitle}>Three steps to automated outreach</p>
        <div style={S.stepsGrid}>
          {[
            { step: "01", title: "Anomaly & Risk Alerts", desc: "Monitoring Transactions." },
            { step: "02", title: "Behavioral Analytics", desc: "View Dashboard." },
            { step: "03", title: "Interactive Dashboards", desc: "Spending Analytic Charts." },
          ].map((s, i) => (
            <div key={i} style={S.stepCard}>
              <div style={S.stepNumber}>{s.step}</div>
              <h3 style={S.stepTitle}>{s.title}</h3>
              <p style={S.stepDesc}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      <section style={S.pricing}>
        <h2 style={S.sectionTitle}>Simple pricing</h2>
        <p style={S.sectionSubtitle}>One plan. Everything included.</p>
        <div style={S.pricingCard}>
          <div style={S.pricingBadge}>MOST POPULAR</div>
          <div style={S.price}>$99<span style={S.pricePer}>/month</span></div>
          <p style={S.pricingDesc}>Everything you need to automate your outreach</p>
          <div style={S.pricingFeatures}>
            {[
              "✅ Credit Card and transaction monitoring",
              "✅ Fraud Alert Notification",
              "✅ Real-time transaction flow",
            ].map((f, i) => (
              <div key={i} style={S.pricingFeature}>{f}</div>
            ))}
          </div>
          <button
            className="cta-btn"
            onClick={() => navigate(user?.role === 'premium' ? '/dashboard' : '/auth')}
            style={{ ...S.ctaBtn, width: "100%", justifyContent: "center" }}
          >
            Get Started <ArrowRight size={18} />
          </button>
        </div>
      </section>

      {/* CTA */}
      <section style={S.ctaSection}>
        <h2 style={S.ctaTitle}>Ready to grow on autopilot?</h2>
        <p style={S.ctaSubtitle}>
          Join businesses using AI to monitor transactions online
        </p>
        <button
          className="cta-btn"
          onClick={() => navigate(user ? '/dashboard' : '/auth')}
          style={S.ctaBtn}
        >
          {user ? 'Open Dashboard' : 'Start Free Today'} <ArrowRight size={18} />
        </button>
      </section>

      {/* Footer */}
      <footer style={S.footer}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center", marginBottom: 8 }}>
          <div style={S.logoIcon}><Zap size={14} color="#fff" /></div>
          <span style={{ ...S.logoText, fontSize: 16 }}>OutreachAI</span>
        </div>
        <p style={{ fontSize: 13, color: "#555" }}>AI-powered outreach automation</p>
        <div style={{ marginTop: 12, display: "flex", gap: 16, justifyContent: "center" }}>
          <a href="/privacy" style={{ fontSize: 12, color: "#444", textDecoration: "none" }}>Privacy Policy</a>
          <a href="/terms" style={{ fontSize: 12, color: "#444", textDecoration: "none" }}>Terms of Service</a>
        </div>
      </footer>
    </div>
  );
}

const S = {
  page: {
    minHeight: "100vh",
    background: "#060818",
    color: "#E8E8EC",
    fontFamily: "'Inter', 'DM Sans', sans-serif",
    position: "relative",
    overflow: "hidden",
  },
  glow1: {
    position: "fixed",
    top: -150, right: -150,
    width: 600, height: 600,
    background: "rgba(99,102,241,0.12)",
    borderRadius: "50%",
    filter: "blur(150px)",
    pointerEvents: "none",
  },
  glow2: {
    position: "fixed",
    bottom: -150, left: -150,
    width: 600, height: 600,
    background: "rgba(139,92,246,0.08)",
    borderRadius: "50%",
    filter: "blur(150px)",
    pointerEvents: "none",
  },
  header: {
    borderBottom: "1px solid #0f1729",
    padding: "0 24px",
    position: "sticky",
    top: 0,
    background: "rgba(6,8,24,0.95)",
    backdropFilter: "blur(16px)",
    zIndex: 100,
  },
  headerInner: {
    maxWidth: 1100,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 64,
  },
  logoIcon: {
    width: 32, height: 32,
    borderRadius: 8,
    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoText: {
    fontSize: 20,
    fontWeight: 700,
    color: "#E8E8EC",
    letterSpacing: "-0.02em",
  },
  logoBeta: {
    fontSize: 10,
    fontWeight: 600,
    color: "#6366f1",
    border: "1px solid #6366f1",
    borderRadius: 4,
    padding: "2px 6px",
    letterSpacing: "0.08em",
  },
  navBtn: {
    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    padding: "9px 18px",
    borderRadius: 8,
  },
  signOutBtn: {
    background: "none",
    border: "1px solid #1a1f3a",
    color: "#555",
    cursor: "pointer",
    fontSize: 13,
    padding: "8px 14px",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  hero: {
    maxWidth: 760,
    margin: "0 auto",
    padding: "120px 24px 80px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    color: "#6366f1",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 24,
    background: "rgba(99,102,241,0.1)",
    padding: "6px 14px",
    borderRadius: 20,
    border: "1px solid rgba(99,102,241,0.2)",
  },
  heroTitle: {
    fontSize: "clamp(42px, 7vw, 72px)",
    fontWeight: 800,
    lineHeight: 1.05,
    color: "#F0F0F5",
    marginBottom: 20,
    letterSpacing: "-0.03em",
  },
  heroSubtitle: {
    fontSize: 18,
    color: "#555",
    lineHeight: 1.75,
    marginBottom: 32,
  },
  tag: {
    fontSize: 12,
    color: "#4a5568",
    border: "1px solid #1a1f3a",
    borderRadius: 20,
    padding: "5px 14px",
    background: "#0a0d1f",
  },
  ctaBtn: {
    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    padding: "16px 40px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    transition: "all 0.2s",
  },
  stats: {
    display: "flex",
    justifyContent: "center",
    gap: 24,
    flexWrap: "wrap",
    padding: "48px 24px",
    borderTop: "1px solid #0f1729",
    borderBottom: "1px solid #0f1729",
    position: "relative",
    zIndex: 1,
  },
  statCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    padding: "20px 32px",
    border: "1px solid #0f1729",
    borderRadius: 12,
    background: "#0a0d1f",
    transition: "all 0.2s",
    minWidth: 120,
  },
  statNum: {
    fontSize: 32,
    fontWeight: 800,
    color: "#6366f1",
    letterSpacing: "-0.02em",
  },
  statLabel: {
    fontSize: 11,
    color: "#444",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },
  features: {
    maxWidth: 1000,
    margin: "0 auto",
    padding: "100px 24px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  sectionTitle: {
    fontSize: 36,
    fontWeight: 800,
    color: "#F0F0F5",
    marginBottom: 12,
    letterSpacing: "-0.02em",
  },
  sectionSubtitle: {
    fontSize: 16,
    color: "#555",
    marginBottom: 56,
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 24,
  },
  featureCard: {
    background: "#0a0d1f",
    border: "1px solid #0f1729",
    borderRadius: 16,
    padding: "36px 28px",
    textAlign: "left",
  },
  featureIcon: {
    width: 52,
    height: 52,
    borderRadius: 14,
    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
  },
  featureTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#F0F0F5",
    marginBottom: 10,
    letterSpacing: "-0.01em",
  },
  featureText: {
    fontSize: 14,
    color: "#555",
    lineHeight: 1.75,
  },
  howItWorks: {
    maxWidth: 1000,
    margin: "0 auto",
    padding: "0 24px 100px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  stepsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: 24,
  },
  stepCard: {
    background: "#0a0d1f",
    border: "1px solid #0f1729",
    borderRadius: 16,
    padding: "36px 28px",
    textAlign: "left",
  },
  stepNumber: {
    fontSize: 48,
    fontWeight: 800,
    color: "rgba(99,102,241,0.2)",
    lineHeight: 1,
    marginBottom: 16,
    letterSpacing: "-0.03em",
  },
  stepTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#F0F0F5",
    marginBottom: 8,
  },
  stepDesc: {
    fontSize: 14,
    color: "#555",
    lineHeight: 1.75,
  },
  pricing: {
    maxWidth: 480,
    margin: "0 auto",
    padding: "0 24px 100px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  pricingCard: {
    background: "#0a0d1f",
    border: "1px solid rgba(99,102,241,0.3)",
    borderRadius: 20,
    padding: "40px 36px",
    position: "relative",
  },
  pricingBadge: {
    position: "absolute",
    top: -12,
    left: "50%",
    transform: "translateX(-50%)",
    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
    color: "#fff",
    fontSize: 10,
    fontWeight: 700,
    padding: "4px 14px",
    borderRadius: 20,
    letterSpacing: "0.1em",
  },
  price: {
    fontSize: 64,
    fontWeight: 800,
    color: "#F0F0F5",
    letterSpacing: "-0.03em",
    marginBottom: 8,
  },
  pricePer: {
    fontSize: 20,
    color: "#555",
    fontWeight: 400,
  },
  pricingDesc: {
    fontSize: 14,
    color: "#555",
    marginBottom: 28,
  },
  pricingFeatures: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginBottom: 32,
    textAlign: "left",
  },
  pricingFeature: {
    fontSize: 14,
    color: "#888",
  },
  ctaSection: {
    textAlign: "center",
    padding: "80px 24px",
    borderTop: "1px solid #0f1729",
    position: "relative",
    zIndex: 1,
  },
  ctaTitle: {
    fontSize: 40,
    fontWeight: 800,
    color: "#F0F0F5",
    marginBottom: 16,
    letterSpacing: "-0.02em",
  },
  ctaSubtitle: {
    fontSize: 16,
    color: "#555",
    marginBottom: 32,
    maxWidth: 500,
    margin: "0 auto 32px",
  },
  footer: {
    borderTop: "1px solid #0f1729",
    padding: "40px 24px",
    textAlign: "center",
  },
};



